import React from "react";
import { PenLine, Sparkles, Loader2, CheckCircle2 } from "lucide-react";

const StepContentMethod = ({
  contentMethod,
  setContentMethod,
  aiPrompt,
  setAiPrompt,
  aiGenerating,
  aiGenerated,
  generateWithAI,
}) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <button
          type="button"
          onClick={() => setContentMethod("manual")}
          className={`text-left p-4 rounded-lg border ${
            contentMethod === "manual" ? "border-primary bg-primary_tint" : "border-border bg-surface_alt"
          }`}
        >
          <div className="flex items-center gap-2 mb-1.5">
            <PenLine size={16} className={contentMethod === "manual" ? "text-primary" : "text-text_muted"} />
            <span className="text-sm font-semibold text-text_primary">Write manually</span>
          </div>
          <p className="text-xs text-text_muted">Author the subject, heading, and body yourself in the content editor.</p>
        </button>

        <button
          type="button"
          onClick={() => setContentMethod("ai")}
          className={`text-left p-4 rounded-lg border ${
            contentMethod === "ai" ? "border-primary bg-primary_tint" : "border-border bg-surface_alt"
          }`}
        >
          <div className="flex items-center gap-2 mb-1.5">
            <Sparkles size={16} className={contentMethod === "ai" ? "text-primary" : "text-text_muted"} />
            <span className="text-sm font-semibold text-text_primary">Generate with AI</span>
          </div>
          <p className="text-xs text-text_muted">Describe the email in plain language and let AI draft the content for you to review and edit.</p>
        </button>
      </div>

      {contentMethod === "ai" && (
        <div className="p-4 rounded-lg border border-border bg-surface space-y-3">
          <label className="block text-xs font-medium text-text_secondary">
            Describe the email you want
          </label>
          <textarea
            value={aiPrompt}
            onChange={(e) => setAiPrompt(e.target.value)}
            rows={4}
            placeholder="e.g. Notify a user that their project has been approved, greet them by first name and include a link to view the project."
            className="w-full px-3 py-2 text-sm rounded-lg border border-border bg-surface_alt text-text_primary placeholder:text-text_muted focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition"
          />
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={generateWithAI}
              disabled={aiGenerating || !aiPrompt.trim()}
              className="inline-flex items-center gap-1.5 px-4 py-2 text-xs font-semibold rounded-lg bg-primary text-white disabled:opacity-60 shadow-sm"
            >
              {aiGenerating ? (
                <><Loader2 size={13} className="animate-spin" /> Generating…</>
              ) : (
                <><Sparkles size={13} /> Generate</>
              )}
            </button>
            {aiGenerated && !aiGenerating && (
              <span className="inline-flex items-center gap-1 text-xs font-medium text-success">
                <CheckCircle2 size={13} /> Content generated — review it on the next step
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default StepContentMethod;
